<template>
  <keep-alive>
    <v-dialog
      :model-value="show.bookDemo"
      width="858"
      content-class="book-demo-dialog-content"
      @click:outside="setModal({ field: 'bookDemo', value: false })"
    >
      <div
        class="meetings-iframe-container"
        data-src="https://meetings.hubspot.com/phillip-reyland/onboarding-call?embed=true"
      >
        <div
          class="close-icon-container"
          @click="setModal({ field: 'bookDemo', value: false })"
        >
          <div class="close-icon">
            <DpplSvg file-name="icon-close" />
          </div>
        </div>
      </div>
    </v-dialog>
  </keep-alive>
</template>

<script>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import { mapState, mapActions } from 'pinia';
import { useModals } from '@/stores/modals/modals';

let scriptLoaded = false;

export default {
  name: 'BookDemoModal',
  components: {
    DpplSvg,
  },
  computed: {
    ...mapState(useModals, ['show']),
  },
  watch: {
    'show.bookDemo': {
      handler(value) {
        if (!value) {
          return;
        }

        if (scriptLoaded) {
          return;
        }

        const script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute(
          'src',
          'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js',
        );

        document.body.appendChild(script);
        scriptLoaded = true;
      },
    },
  },
  methods: {
    ...mapActions(useModals, ['setModal']),
  },
};
</script>

<style lang="less" scoped>
.meetings-iframe-container {
  margin-top: -16px;
  background-color: @text-brand;
}
.close-icon-container {
  height: 0;
  .close-icon {
    position: relative;
    width: 52px;
    top: 28px;
    right: 18px;
    border-radius: 40px;
    margin-left: auto;
    background-color: @white;
    padding: 16px;
    cursor: pointer;
    &:hover {
      background-color: @text-brand;
    }
  }
}
:deep(.book-demo-dialog-content) {
  overflow: hidden;
  height: 654px;
}
</style>
